import {
  Rectangle,
  Color,
} from "cesium";

/// /// 2次メッシュ3列の可視化 /////////////////////////
export function mesh2ndRect(
  meshcode3rd,
  h,
  c,
  dataname,
  pagedata,
  shikii1,
  shikii2,
  shikii3,
  shikii4,
  hanrei1_color,
  hanrei2_color,
  hanrei3_color,
  hanrei4_color,
  hanrei5_color,
  ratio,
  alpha,
  defaultratio,
  year1_nihonsokuchi
) {
  var strMeshcoe = String(meshcode3rd);
  var p = parseInt(strMeshcoe.slice(0, 2));
  var u = parseInt(strMeshcoe.slice(2, 4));
  var q = parseInt(strMeshcoe.slice(4, 5));
  var v = parseInt(strMeshcoe.slice(5, 6));
  // var r = parseInt(strMeshcoe.slice(6,7));
  // var w = parseInt(strMeshcoe.slice(7,8));

  var lat;
  var lon;

// console.log(year1_nihonsokuchi);

if(year1_nihonsokuchi){
  var lat_p = p / 1.5 + q / 12;
  var lon_p = u + 100 + v * 0.125;
  lat =  lat_p - 0.00010695 * lat_p + 0.000017464 * lon_p + 0.0046017;
  lon = lon_p - 0.000046038 * lat_p - 0.000083043 * lon_p + 0.01004;
// 緯度（世界測地系）＝緯度（日本測地系）－0.00010695×緯度（日本測地系）＋0.000017464×経度（日本測地系）＋0.0046017
// 経度（世界測地系）＝経度（日本測地系）－0.000046038×緯度（日本測地系）－0.000083043×経度（日本測地系）＋0.01004
// console.log("日本測地");
} else {
  lat = p / 1.5 + q / 12;
  lon = u + 100 + v * 0.125;
  // console.log("世界測地");
}

  var latc = lat + 0.08333333 / 2;
  var lonc = lon + 0.125 / 2;
  // var latcpre = lat + 0.08333333/2
  // var loncpre = lon + 0.125/2
  // var latc = latcpre.toPrecision(6)
  // var lonc = loncpre.toPrecision(6)

  var color1;
  if (c >= shikii1) {
    color1 = hanrei1_color;
  } else if (c >= shikii2) {
    color1 = hanrei2_color;
  } else if (c >= shikii3) {
    color1 = hanrei3_color;
  } else if (c >= shikii4) {
    color1 = hanrei4_color;
  } else {
    color1 = hanrei5_color || hanrei4_color;
  }

  var ans_entities = {
    parent: dataname,
    // id:meshcode3rd ,
    // description : "<p>"+meshcode3rd+"</p><p>"+h+"</p><p>"+c+"</p>",
    name: lonc + "," + latc + "," + meshcode3rd + "," + h + "," + c,
    rectangle: {
      coordinates: Rectangle.fromDegrees(
        lon,
        lat,
        lon + 0.125,
        lat + 0.08333333
      ),
      height: 0,
      extrudedHeight: defaultratio * h * ratio,
      material: Color.fromCssColorString(color1),
      // material : Color.fromRgba( color_gbra )
      outline: true,
      outlineColor: "white",
      outlineWidth: 1,
      // shadows : ShadowMode.ENABLED
    },
  };
  return ans_entities;
}
/// ///////////////////////// 2次メッシュ3列の可視化 ///